<template>
  <div class="container">
      <el-form :model="form" inline ref="refForm" :rules="rules">
        <el-form-item class="small_label" :label="$t('common.address') + ':'" prop="address">
          <el-input
            v-model.trim="form.address"
            name="address"
            type="text"
            autocomplete="on"
            clearable
            size="small"
            style="width: 200px;"
            maxlength="255"
          />
        </el-form-item>
        <el-form-item class="small_label" :label="$t('common.device') + '/' + $t('common.componentName') + ':'"
                      prop="deviceName">
          <el-input
            v-model.trim="form.deviceName"
            name="deviceName"
            type="text"
            autocomplete="on"
            clearable
            size="small"
            style="width: 200px;"
            maxlength="64"
          />
        </el-form-item>
        <el-form-item class="small_label" :label="$t('common.device') + '/' + $t('common.componentModel') + ':'"
                      prop="deviceModel">
          <el-input
            v-model.trim="form.deviceModel"
            name="deviceModel"
            type="text"
            autocomplete="on"
            clearable
            size="small"
            style="width: 200px;"
            maxlength="64"
          />
        </el-form-item>
        <el-form-item class="small_label" :label="$t('common.device') + '/'+ $t('common.componentNumber') + ':'"
                      prop="deviceNumber">
          <el-input
            v-model.trim="form.deviceNumber"
            name="deviceNumber"
            type="text"
            autocomplete="on"
            clearable
            size="small"
            style="width: 200px;"
            maxlength="64"
          />
        </el-form-item>
        <el-form-item :label="$t('common.componentSerialNo') + ':'" prop="componentSerialNo">
          <el-input
            v-model.trim="form.deviceSerialNo"
            name="componentSerialNo"
            type="text"
            autocomplete="on"
            clearable
            size="small"
            maxlength="255"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset">{{ $t('common.reset') }}</el-button>
          <el-button type="primary" size="small" @click="queryDevice">
            {{ $t('common.query') }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="target-container">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('common.device')" name="device"></el-tab-pane>
          <el-tab-pane :label="$t('common.component')" name="component"></el-tab-pane>
        </el-tabs>
        <el-table
          ref="table"
          border
          height="100%"
          :data="deviceList"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          @selection-change="handleSelectionChange"
          row-key="id"
          v-show="activeName === 'device'">
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true">
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table
                max-height="100%"
                border
                :data="scope.row.subDevice"
                :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
                :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
                header-cell-class-name="headerCellName"
                @selection-change="handleSelectionChange"
                row-key="id">
                <el-table-column prop="addr" :label="$t('common.address')"/>
                <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
                <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
                <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
                <el-table-column prop="productionDate" :label="$t('common.productionDate')">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.productionDate) }}
                  </template>
                </el-table-column>
                <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
                <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
                <el-table-column prop="status" :label="$t('common.status')">
                  <template slot-scope="scope">
                    {{ subDeviceStatusVal(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.deviceCategory')">
            <template slot-scope="scope">
              {{ deviceCategoryVal(scope.row.flag) }}
            </template>
          </el-table-column>
          <el-table-column prop="addr" :label="$t('common.address')"/>
          <el-table-column prop="deviceName" :label="$t('common.deviceName')"/>
          <el-table-column prop="deviceModel" :label="$t('common.deviceModel')"/>
          <el-table-column prop="deviceNo" :label="$t('common.deviceNumber')"/>
          <el-table-column prop="productionDate" :label="$t('common.productionDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.productionDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="installationDate" :label="$t('common.installDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.installationDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
          <el-table-column :label="$t('common.status')">
            <template slot-scope="scope">
              {{ deviceStatusVal(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
        </el-table>
        <el-table
          height="100%"
          border
          :data="subDeviceList"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          @selection-change="handleSubSelectionChange"
          row-key="id"
          v-show="activeName === 'component'">
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true">
          </el-table-column>
          <el-table-column prop="addr" :label="$t('common.address')"/>
          <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
          <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
          <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
          <el-table-column prop="productionDate" :label="$t('common.productionDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.productionDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
          <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
          <el-table-column prop="status" :label="$t('common.status')">
            <template slot-scope="scope">
              {{ subDeviceStatusVal(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
        </el-table>
      </div>
      <pagination
        v-show="activeName === 'device'"
        :total="totalCount"
        :pageSize="perpage"
        :current-page.sync="page"
        @current-change="onChangePage"
      />
      <pagination
        v-show="activeName === 'component'"
        :total="totalCountSub"
        :pageSize="perpage"
        :current-page.sync="pageSub"
        @current-change="onChangePageSub"
      />
    <div class="control-container">
      <div>
        <span style="color: #404040; font-size: 14px;">{{ $t('common.selected') }}<span
          style="color: #EC7900; font-size: 24px;">{{ selectedDeviceCount }}</span>{{ $t('common.device') }}</span>
        <span v-if="selectedDeviceLinkedSubCount"
              style="color: #404040; font-size: 14px;">({{ $t('common.device') }}{{ $t('common.under') }}{{ $t('common.aTotalOf') }}<span
          style="color: #EC7900; font-size: 24px;">{{ selectedDeviceLinkedSubCount }}</span>{{ $t('common.component') }})</span>
        <span style="color: #404040; font-size: 14px;">,{{ $t('common.selected') }}<span
          style="color: #EC7900; font-size: 24px;">{{ selectedSubDeviceCount }}</span>{{ $t('common.component') }}</span>
      </div>
      <span>
        <el-button @click="nextStep" size="small" class="sure-button">
          {{ $t('common.nextStep') }}
        </el-button>
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {defaultCategoryTypes, defaultDeviceStatus, defaultSubDeviceStatus} from "@/utils/defines";
import {devicesList} from "@/api/device";
import i18n from "@/lang";
import {
  Pagination,
} from '@/components';

const defaultForm = {
  address: undefined,
  deviceName: undefined,
  deviceModel: undefined,
  deviceNumber: undefined,
  deviceSerialNo: undefined,
};

const categoryTypes = {
  ...defaultCategoryTypes,
  100: {
    val: 100,
    explain: i18n.t('common.component'),
  }
};

export default {
  name: "choose-device",
  components: {
    Pagination,
  },
  data() {
    return {
      form: {...defaultForm},
      rules: {},
      activeName: 'device',
      deviceList: [],
      subDeviceList: [],
      totalCount: 0,
      perpage: 10,
      page: 1,
      totalCountSub: 0,
      pageSub: 1,
      selectDevice: [],
      selectSubDevice: [],
      searchParams: {...defaultForm},
      deviceFlag: false,
      subDeviceFlag: false,
    };
  },
  computed: {
    selectedDeviceCount() {
      return this.selectDevice.length;
    },
    selectedDeviceLinkedSubCount() {
      let count = 0;
      for (let row of this.selectDevice) {
        count += (row.subDevice || []).length;
      }
      return count;
    },
    selectedSubDeviceCount() {
      return this.selectSubDevice.length;
    },
  },
  mounted() {
    this.devicesListGet();
    this.subDeviceListGet();
  },
  methods: {
    reset() {
      this.page = 1;
      this.pageSub = 1;
      this.form = Object.assign({}, defaultForm);
      this.searchParams = Object.assign({}, defaultForm);
      this.devicesListGet();
      this.subDeviceListGet();
    },
    queryDevice() {
      this.page = 1;
      this.pageSub = 1;
      this.searchParams = {...this.form};
      this.deviceFlag = true;
      this.subDeviceFlag = true;
      this.devicesListGet();
      this.subDeviceListGet();
    },
    async devicesListGet() {
      const {
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        deviceSerialNo,
      } = this.searchParams;
      const {
        page,
        perpage,
      } = this;
      try {
        const res = await devicesList({
          flag: [1, 2, 3],
          page,
          perpage,
          addr: address || undefined,
          deviceName: deviceName || undefined,
          deviceModel: deviceModel || undefined,
          deviceNo: deviceNumber || undefined,
          deviceSerialNo: deviceSerialNo || undefined,
        });
        const {
          data,
        } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        this.deviceList = data.records || [];
      } catch (e) {
        // do nothing.
      } finally {
        if (this.deviceFlag) {
          this.deviceFlag = false;
          if (!this.subDeviceFlag) {
            if (this.deviceList.length === 0) {
              if (this.subDeviceList.length > 0) {
                this.activeName = 'component';
              }
            } else {
              if (this.subDeviceList.length === 0) {
                this.activeName = 'device';
              }
            }
          }
        }
      }
    },
    async subDeviceListGet() {
      const {
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        deviceSerialNo,
      } = this.searchParams;
      const {
        pageSub,
        perpage,
      } = this;
      try {
        const res = await devicesList({
          flag: [100, 100],
          page: pageSub,
          perpage: perpage,
          addr: address || undefined,
          deviceName: deviceName || undefined,
          deviceModel: deviceModel || undefined,
          deviceNo: deviceNumber || undefined,
          isUsed: 0,
          deviceSerialNo: deviceSerialNo || undefined,
        });
        const {
          data,
        } = res;
        if (data.count !== undefined) {
          this.totalCountSub = data.count;
        }
        this.subDeviceList = data.records || [];
      } catch (e) {
        // do nothing.
      } finally {
        if (this.subDeviceFlag) {
          this.subDeviceFlag = false;
          if (!this.deviceFlag) {
            if (this.deviceList.length === 0) {
              if (this.subDeviceList.length > 0) {
                this.activeName = 'component';
              }
            } else {
              if (this.subDeviceList.length === 0) {
                this.activeName = 'device';
              }
            }
          }
        }
      }
    },
    handleSelectionChange(val) {
      this.selectDevice = val;
    },
    handleSubSelectionChange(val) {
      this.selectSubDevice = val;
    },
    deviceCategoryVal(flag) {
      return categoryTypes[flag] ? `${categoryTypes[flag].explain}` : ''
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
    deviceStatusVal(row) {
      const {
        status,
      } = row;
      const deviceStatus = defaultDeviceStatus[String(status)];
      return deviceStatus ? deviceStatus.explain : status;
    },
    subDeviceStatusVal(row) {
      const {
        status,
      } = row;
      const subDeviceStatus = defaultSubDeviceStatus[String(status)];
      return subDeviceStatus ? subDeviceStatus.explain : status;
    },
    onChangePage() {
      this.devicesListGet();
    },
    onChangePageSub() {
      this.subDeviceListGet();
    },
    nextStep() {
      const {
        selectDevice,
        selectSubDevice,
      } = this;
      if (selectDevice.length === 0 && selectSubDevice.length === 0) {
        this.$message({
          type: 'info',
          message: this.$t('device.selectTheDeviceOrComponentFirst'),
        });
        return;
      }
      this.$emit('nexStep');
      this.$emit('select', {selectDevice, selectSubDevice})
    }
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.el-form {
  padding: 10px 20px 0;
  border-bottom: 1px solid #E5E5E5;
}

.el-form-item {
  margin-bottom: 10px;
}

.control-container {
  background: #F5F5F5;
  padding: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
}

.target-container {
  flex: 1;
  display: -webkit-flex;
  display: flex;
  margin: 20px 20px 0;
  height: 100%;
  overflow: auto;
  flex-direction: column;
}

.sure-button {
  background: #EC7900;
  color: white;
}
.topContainer {
}
</style>
<style>
.headerCellName {
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
}

.small_label .el-form-item__label {
  font-size: 12px;
}
</style>
